'use strict';

require('core/quote');
